module.exports = __webpack_public_path__ + "static/niegolewskich-img-8-ca07cfeeedd0a1009a75d7feac19462a.jpg";